import { editOrganization } from 'api/membership';
import { IPatchObject } from 'interfaces/request';
import { IMutationProps } from 'interfaces/ui';
import {
  displayErrorArrayNotifications,
  displaySuccessNotification,
} from 'modules/Notifications';
import { useMutationWithResultNotification } from '../useMutationWithResultNotification';

function usePatchOrganization(
  organizationId: string,
  options?: IMutationProps
) {
  const { successFb } = options || {};

  return useMutationWithResultNotification({
    asyncApiFunction: async (data: IPatchObject[]) => {
      await editOrganization(organizationId, data);
    },
    resetOnResult: true,
    onSuccess: () => {
      displaySuccessNotification('MyOrganizations.editOrganization.success');
      successFb && successFb();
    },
    onErrorArray: (errorArray) => {
      displayErrorArrayNotifications(
        errorArray,
        'MyOrganizations.editOrganization.errors'
      );
    },
  });
}

export default usePatchOrganization;
